// The shared page title (app.md §7). Plain Title3 — with the app title
// rendered as a small wordmark (App.tsx), the page title is the page's only
// large heading and needs no decoration. (A brand-filled pill was tried
// 2026-07-07 and retired the same day — it read as a button. The component
// stays as the single place every page's title is styled.)
import type { ReactNode } from 'react'
import { Title3 } from '@fluentui/react-components'

export function ScreenTitle({ children }: { children: ReactNode }) {
  return <Title3>{children}</Title3>
}
